import styled, { css } from 'styled-components'

export const CampaignTitleWrapper = styled.div`
  ${({ theme }) => css`
    display: flex;
    align-items: center;

    gap: 0.5rem;
    min-width: 12rem;
    max-width: 16rem;

    a {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: flex-start;
      line-height: 1.125;

      .title {
        margin-bottom: ${theme.spacings.tiny};
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
        overflow: hidden;
        color: ${theme.colors.primary};
        font-size: ${theme.font.sizes.xsmall};
        overflow-wrap: anywhere;
      }
    }
  `}
`

export const TitleWrapper = styled.div`
  ${({ theme }) => css`
    display: flex;
    align-items: center;
    gap: 0.5rem;
    max-width: 22rem;

    .mainInfo {
      line-height: 1;
      min-width: 200px;

      .title {
        margin-bottom: ${theme.spacings.tiny};
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
        overflow: hidden;
        color: ${theme.colors.primary};
        font-size: ${theme.font.sizes.xsmall};
        overflow-wrap: anywhere;
      }

      .description {
        font-size: ${theme.font.sizes.xsmall};
        display: inline-flex;

        > div {
          margin-bottom: 0;
        }
      }
    }
  `}
`
